import { useEffect, useState } from 'react';
import { Find, FindStateType, ModalStateType } from '@components/loginModal';
import Login from '@components/acca/tutorialLoginModal/login';
import { useUserInfo } from '@repository/auth/useUserInfo';
import TermsModal from './termsModal';
import { useApplyTutorial } from '../test/query/useApply';
import { useTermsCheckNewMutation } from '../test/query/useTerms';
import { TERMS } from '@domain/constant/termsType';
import { V2Route } from '@utils/routeUtil';

import UrlUtil from '@utils/urlUtil';
import classnames from 'classnames/bind';
import styles from './tutorialLoginModal.module.scss';

const cx = classnames.bind(styles);

const TutorialLoginModal = () => {
  const [modalState, setModalState] = useState<ModalStateType>('LOGIN');
  const [findState, setFindState] = useState<FindStateType>('ID');
  const [termsModalVisible, setTermsModalVisible] = useState(false);

  const { data: userInfo } = useUserInfo();
  const isLogin = !!userInfo?.id;

  const { refetch } = useApplyTutorial(isLogin);
  const { mutateAsync: checkTermsMutateAsync } = useTermsCheckNewMutation();

  //튜토리얼 응시 하기 버튼 이벤트
  const onApplyTutorial = async () => {
    await refetch().then(({ data }) => {
      const { url, token } = data;
      const accTutorialUrl = V2Route.getAccaTutorialPage(url);
      UrlUtil.openWindowWithPost(accTutorialUrl, { Authorization: `Bearer ${token}` }, false);
    });
  };

  //약관 동의 여부 체크
  const onClickTutorialApplyBtn = async () => {
    const { existsNewTermsAgree } = await checkTermsMutateAsync(TERMS.ACC_TRIAL_PRIVACY_POLICY);
    if (existsNewTermsAgree) {
      setTermsModalVisible(true);
      return;
    }

    await onApplyTutorial();
  };

  useEffect(() => {
    if (isLogin) onClickTutorialApplyBtn();
  }, [isLogin]);

  return (
    <>
      <div className={cx('container')}>
        <div className={cx('modalWrap', { visible: !isLogin })}>
          {modalState === 'LOGIN' && <Login setModalState={setModalState} setFindState={setFindState} />}
          {modalState === 'FIND' && (
            <Find findState={findState} setFindState={setFindState} setModalState={setModalState} />
          )}
        </div>
      </div>
      <TermsModal visible={termsModalVisible} onConfirm={onApplyTutorial} />
    </>
  );
};

export default TutorialLoginModal;
